import { Display, Moon, Sun } from "@gravity-ui/icons";
import { Icon } from "@gravity-ui/uikit";

export const themes = [
  { value: "light", content: <Icon data={Sun} />, title: "Светлая тема" },
  { value: "dark", content: <Icon data={Moon} />, title: "Темная тема" },
  {
    value: "system",
    content: <Icon data={Display} />,
    title: "Системная тема",
  },
];
